// Basket page (Phase 5; woocommerce/cart/cart.php, inc/basket.php). Every change goes through WooCommerce's own
// handlers, as the page does without JS: the quantities form (update_cart), the remove links, the postcode (the
// shipping calculator). Here they're sent in the background and the returned page's basket and header basket
// buttons are swapped in, so totals, delivery and advice always come from the server.

var timer;

function root() {
    return document.querySelector('[data-basket]');
}

function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-basket]'), old = root();
    if (!fresh || !old) {
        location.reload();
        return;
    }
    var notices = doc.querySelector('.woocommerce-notices-wrapper'), mine = document.querySelector('.woocommerce-notices-wrapper');
    if (notices && mine) {
        mine.innerHTML = notices.innerHTML;
    }
    ['a.hbasket--top', 'a.hbasket--bar', 'a.hbasket--mnav'].forEach(function (sel) {
        var a = doc.querySelector(sel), b = document.querySelector(sel);
        if (a && b) {
            b.outerHTML = a.outerHTML;
        }
    });
    old.replaceWith(fresh);
    live();
    var status = fresh.querySelector('[data-bk-status]');
    if (status) {
        status.textContent = 'Basket updated';
    }
}

function busy(on) {
    var r = root();
    if (r) {
        r.classList.toggle('is-busy', on);
    }
}

function go(url, body) {
    busy(true);
    return fetch(url, {method: body ? 'POST' : 'GET', body: body, credentials: 'same-origin'})
        .then(function (r) {
            return r.text();
        })
        .then(swap)
        .catch(function () {
            location.reload();
        });
}

function cartUrl() {
    return root().querySelector('[data-bk-form]').action;
}

function update() {
    var form = root().querySelector('[data-bk-form]');
    var body = new FormData(form);
    body.set('update_cart', 'Update basket');
    go(form.action, body);
}

function live() {
    var r = root();
    if (r) {
        r.classList.add('is-live'); // hides the "Update basket" button, needed only without JS
    }
}

export function initBasket() {
    if (!root()) {
        return;
    }
    live();
    document.addEventListener('click', function (e) {
        if (!root()) {
            return;
        }
        var step = e.target.closest('[data-basket] [data-step]');
        if (step) {
            var input = step.parentNode.querySelector('[data-bk-qty]');
            input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (+step.dataset.step));
            clearTimeout(timer);
            timer = setTimeout(update, 600);
            return;
        }
        var remove = e.target.closest('[data-basket] [data-bk-remove]');
        if (remove) {
            e.preventDefault();
            go(remove.href);
            return;
        }
        var change = e.target.closest('[data-bk-change]');
        if (change) {
            var field = root().querySelector('.bk-pc-field');
            field.hidden = false;
            field.querySelector('input').focus();
        }
    });
    document.addEventListener('input', function (e) {
        if (e.target.matches('[data-basket] [data-bk-qty]')) {
            clearTimeout(timer);
            timer = setTimeout(update, 800);
        }
    });
    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!root() || !root().contains(form)) {
            return;
        }
        e.preventDefault();
        if (form.matches('[data-bk-form]')) {
            clearTimeout(timer);
            update();
        } else if (form.matches('[data-bk-postcode]')) {
            var body = new FormData(form);
            body.set('calc_shipping', '1');
            go(form.action, body);
        } else if (form.matches('[data-jfj-add]')) {
            // A suggestion's Add (tins, care product, cross-sells): add, then show the basket again.
            var add = new FormData(form);
            add.set('product_id', add.get('add-to-cart'));
            add.delete('add-to-cart');
            busy(true);
            var url = (window.wc_add_to_cart_params && wc_add_to_cart_params.wc_ajax_url) || '/?wc-ajax=%%endpoint%%';
            fetch(url.replace('%%endpoint%%', 'jfj_add'), {method: 'POST', body: add, credentials: 'same-origin'})
                .then(function () {
                    return go(cartUrl());
                })
                .catch(function () {
                    form.submit();
                });
        }
    });
}
